<template>
  <div class="bgBlue">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="1"></HeaderNav>
    <Banner :banner="bannerList"  @click="loseFocus()"></Banner>
    <div class="pro_box container">	
	    <ul>
            <li>
                <a @click="toDetail(1)"><i>清凝养护</i>
                <div class="li_img"><img src="static/picture/1-210g2153g3t6.png"></div>
                <div class="li_text">
                    <p>清凝面膜<em>BLACK MASK</em></p>
                    <span>以黑吸黑 净澈焕亮</span>
                </div></a>
            </li><li>
                <a @click="toDetail(2)"><i>补水之星</i>
                <div class="li_img"><img src="static/picture/1-210220152333248.jpg"></div>
                <div class="li_text">
                    <p>LEWA面膜<em>MOIST MASK</em></p>
                    <span>密集补水 水润呵护</span>
                </div></a>
            </li><li>
                <a @click="toDetail(3)"><i>精简护理</i>
                <div class="li_img"><img src="static/picture/1-210220152356345.jpg"></div>
                <div class="li_text">
                    <p>LEWA精华<em>GRACE ESSENCE</em></p>
                    <span>菁纯焕活 细致肌肤</span>
                </div></a>
            </li> 
        </ul>
    </div>
    <hr class="hr_1 mb80">
    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import Banner from '../../components/Banner.vue';
import RightNav from '../../components/RightNav.vue';
import { apiGetDetail, apiChangeOther, apiAddNotes } from '../../api/job.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banner: Banner,
    RightNav: RightNav
  },
  data() {
    return {
      advertInfo: { image: '../../static/pC/ad.png' },
      id:'',
      login: false, //是否登录
      userInfo: [] ,//是否登录--用户信息
      bannerList: [
        {url:'static/picture/luara_banner1.jpg'},
        {url:'static/picture/luara_banner2.jpg'},
        {url:'static/picture/luara_banner3.jpg'},
      ],
    };
  },
  created() {

  },
  methods: {
    toDetail(id){
		  this.$router.push({ path: '/messageIndex', query: { id:id } });
	  },
    //跳转到外部链接
    linkOut(url){
      if(url.includes('https://') || url.includes('http://') ){
      	window.location.href = url
      }else{
      	window.location.href = `https://${url}`
      }
    },
    
    //判断是否登录
    judgeLogin() {
      if (sessionStorage.getItem('login') != null && sessionStorage.getItem('login') != '') {
        this.login = sessionStorage.getItem('login');
        if (sessionStorage.getItem('userInfo') != null && sessionStorage.getItem('userInfo') != '') {
          var userInfo = sessionStorage.getItem('userInfo');
          this.userInfo = JSON.parse(userInfo);
        }
      }
    }
  }
};
</script>
<style scoped>
/*------------luara.html  start----------------*/	
.classify_box{
	width: 100%;
	height: 116px;
	overflow: hidden;
	background: #fafafa;
}
.classify_box p{
	margin-top: 12px;
	text-align: right;
	padding-right: 60px;
	font-size: 12px;
	color: #000000;
	font-family: Font_Light;
}
.classify_box select{
	width: 198px;
	padding: 0 15px;
	height: 40px;
	line-height: 40px;
	border: 1px solid #000;
	background: none;
	float: right;
	margin: 12px 30px 0 0;
	font-size: 14px;
	color: #000000;
	font-family: Font_Light;
}

.pro_box{
	overflow: hidden;
}
.pro_box li{
	width: 30%;
	margin: 0 5% 8% 0;
	float: left;
	text-align: center;
	overflow: hidden;
	position: relative;
}
.pro_box li:nth-child(3n){
	margin: 0 0 8% 0;
}
.pro_box li a{
	color: #000;
}
.pro_box li a:hover{
	color: #000;
}
.pro_box li i{
	display: block;
	width: 80px;
	text-align: center;
	height: 20px;
	line-height: 20px;
	letter-spacing: 1px;
	font-style: normal;
	font-size: 13px;
	font-family: Font_Regular;
	border: 1px solid #000;
	z-index: 2;
	margin: 40px auto 0;
}
.pro_box li .li_img{
	width: 100%;
	overflow: hidden;
	padding-top: 135%;
	position: relative;
}
.pro_box li .li_img img{
	max-width: 100%;
	max-height: 100%;
	display: block;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	margin: auto;
}
.pro_box li .li_text{
	text-align: center;
}
.pro_box li .li_text p{
	letter-spacing: 2px;
	font-size: 15px;
	font-family: Font_Medium;
    margin: 0 0 10px 0;
}
.pro_box li .li_text p em{
	letter-spacing: 1px;
	display: block;
	font-style: normal;
}
.pro_box li .li_text span{
	display: inline-block;
	padding: 0 16px;
	text-align: center;
	letter-spacing: 2px;
	height: 34px;
	line-height: 34px;
	color: #fff;
	background: #000;
	font-size: 15px;
	font-family: Font_Normal;
}
/*------------luara.html  end----------------*/	
</style>


// WEBPACK FOOTER //
// src/view/Html/BRAND_UPGRADING.vue